import React from 'react';
import {Link} from '@sail/ui';
import type {OpenapiAccountTypeEnum} from '@stripe-internal/data-v1/schema/types';

type Props = {
  children: React.ReactNode;
  accountType?: OpenapiAccountTypeEnum;
};

export const SupportLink = ({children, accountType}: Props) => {
  const getSupportLink = () => {
    switch (accountType) {
      case 'standard':
        return 'https://support.stripe.com/contact';
      default:
        return 'https://support.stripe.com/express/contact';
    }
  };

  return (
    <Link
      href={getSupportLink()}
      rel="noopener noreferrer"
      target="__blank"
      type="secondary"
    >
      {children}
    </Link>
  );
};
